// Types
import type { FormProps } from '@/types/config/form'

const FormConfig: FormProps = { site_key: process.env.TURNSTILE_SITE_KEY || '' }

export default FormConfig
